import React, { useRef, useState } from "react";
import { Dialog } from "@headlessui/react";
import Input from "../controls/Input";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

export default function NextInProcessModal(props) {
  const { buttonMessage, confirmAction, message, setOpen, title } = props;
  const cancelButtonRef = useRef(null);
  const [employeePin, setEmployeePin] = useState(null);

  return (
    <div>
      <div>
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
          <ExclamationCircleIcon
            className="h-11 w-11 text-red-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-base font-normal leading-6 text-gray-800 family-didact"
          >
            {title}
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm font-normal family-didact">{message}</p>
          </div>
        </div>

        <div className="mt-2">
          <Input
            label="User Pin"
            name="pin"
            onChange={(e) => setEmployeePin(e.target.value)}
            value={employeePin}
            labelOn={true}
            type="number"
            inputMode="numeric"
            pattern="\d*"
            step="1"
            min="0"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center sm:grid sm:grid-flow-row-dense sm:grid-cols-2 gap-3">
        <div className="col-span-1 text-right">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
            onClick={() => setOpen({ childComponent: null, open: false })}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-1">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-light family-didact text-white shadow-sm hover:bg-red-500 col-span-1 sm:mt-0"
            onClick={() => confirmAction(employeePin)}
            ref={cancelButtonRef}
          >
            {buttonMessage}
          </button>
        </div>
      </div>
    </div>
  );
}
